import {
  ACTION_PUT_CORPORATE_RATE_CODES,
  ACTION_PUT_CORPORATE_RATE_CODES_SUCCESS,
  ACTION_PUT_CORPORATE_RATE_CODES_FAILURE,
  API_CALL,
} from '../../../configs/ActionTypes';

import * as _ from 'lodash-es';
import { Dispatch } from 'redux';
import { enqueueSnackbarHandler } from '../../Status';

export type datatype = {
  organizationId?: string;
  settingId?: string;
  value?: any;
};

export function putCorporateRateCodes(data: datatype) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());
    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: 'organizations/corporateRateCodes',
        method: 'PUT',
        data: JSON.stringify(data),
        success: (response: any) => {
          if (response.type === 'error') {
            dispatch(requestFailed(response));
            _.get(response.payload, 'payload.userPermissionError', false)
              ? enqueueSnackbarHandler(
                  dispatch,
                  response.payload.payload,
                  'error',
                )
              : enqueueSnackbarHandler(
                  dispatch,
                  { updateCorporateRateCodeFailed: true },
                  'error',
                );
          } else {
            enqueueSnackbarHandler(
              dispatch,
              { updateCorporateRateCode: true },
              'success',
            );
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          dispatch(requestFailed(error));
          _.get(error.payload, 'userPermissionError', false)
            ? enqueueSnackbarHandler(dispatch, error.payload, 'error')
            : enqueueSnackbarHandler(
                dispatch,
                { updateCorporateRateCodeFailed: true },
                'error',
              );
        },
      },
    });
    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_PUT_CORPORATE_RATE_CODES,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_PUT_CORPORATE_RATE_CODES_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_PUT_CORPORATE_RATE_CODES_FAILURE,
    payload: responseJSON,
  };
}
